/* eslint-disable import/extensions */
/* eslint-disable react/react-in-jsx-scope */
import { message, Tooltip, Icon } from 'antd';
import {
  getDeptSubList,
  deleteData,
  editDeptName,
  delBatchs,
  searchList,
  addDept,
  getDeptTypeList,
  getDeptTypeAndRecommmend,
  addBatchDept,
  sort,
  getDeptIds,
  update,
  updateTime,
} from '../../services/department/department';
import { setNanoId } from '@/utils/nanoId';
import { setSpinProps } from '@/utils/utils';

const initState = () => {
  return {
    currentDeptId: '', // 当前部门的id
    columns: [
      {
        title: '部门名称',
        dataIndex: 'deptName',
      },
      {
        title: '部门类型',
        dataIndex: 'personCount',
      },
      {
        title: '部门人数',
        dataIndex: 'subDeptCount',
      },
      {
        title: '关注人数',
        dataIndex: 'followers',
      },
      // {
      //   title: '操作',
      //   dataIndex: '',
      //   render: () => (
      //     <span>
      //       <a href="javascript:;">编辑</a>
      //       <a href="javascript:;">删除</a>
      //     </span>
      //   ),
      // },
    ],
    /**
     *  deptId:	string
     *  deptName:	string 部门名称
     *  personCount: Number 部门内人员数量
     *  subDeptCount: Number 下级部门数
     *  followers: Number 关注人数
     */
    data: [],
    tableId: setNanoId({ str: 'tableKey' }), // tab的key值，每次删除table中的数据重新获取数据之后，table中会有缓存选中项，当你再次选中一个选项的时候，上次删除的选中项会重新出现
    selectedRowKeys: [], // table选中项的deptid数组集合，
    pattern: 'default', // 模式，search： 搜索模式  default： 默认模式
    /**
     * type === 2时
     * 部门类型列表
     * @param {String} typeName: 部门类别名称
     * @param {String} typeSign: 标志
     * type === 1时
     * 部门类型列表
     * @param {String} deptTypeName: 部门类别名称
     * @param {String} deptTypeSign: 标志
     * @param {Array<Object>} recommendDeptNameList: 推荐部门列表 --> deptTypeName & deptTypeSign
     */
    deptTypeList: [],
    tableDataCount: 0,
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
     // 更新相关参数
     date: '',
     status: '',
  };
};

export default {
  namespace: 'countySubDeptartmentForm',

  state: initState(),

  effects: {
    *fetchUpdateTime(_, { call, put }) {
      try {
        const { date, status } = yield call(updateTime);
        yield put({
          type: 'save',
          payload: {
            date,
            status,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchUpdate(_, { call, put }) {
      try {
        yield call(update);
        yield put({
          type: 'fetchUpdateTime',
        })
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 获取下级部门列表数据
    *fetchList({ searchParams, actionBtn, pattern }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { headers, rows } = yield call(getDeptSubList, searchParams);

        headers.forEach(ele => {
          const newEle = ele;
          const { dataIndex, title } = ele;

          if (dataIndex === 'deptName') {
            newEle.width = 230;
            newEle.render = reocord => {
              return (
                <Tooltip title={reocord} placement="topLeft">
                  <div className="table-th-icon">{reocord}</div>
                </Tooltip>
              );
            };
          }

          if (dataIndex === 'personCount') {
            // newEle.align = 'center';
            newEle.title = () => (
              <Tooltip
                placement="topLeft"
                className="table-tip"
                overlayClassName="address-book-dept-manage-tip"
                title="该部门及下属部门的部门成员的人数统计之和"
              >
                {title}
                <Icon type="question-circle" theme="filled" />
              </Tooltip>
            );
          }

          if (dataIndex === 'subDeptCount') {
            // newEle.align = 'center';
            newEle.title = () => (
              <Tooltip
                placement="topLeft"
                className="table-tip"
                title="该部门的下级部门的部门数量之和"
                overlayClassName="address-book-dept-manage-tip"
              >
                {title}
                <Icon type="question-circle" theme="filled" />
              </Tooltip>
            );
          }

          if (dataIndex === 'followers') {
            // newEle.align = 'center';
            newEle.title = () => (
              <Tooltip
                placement="topLeft"
                className="table-tip"
                title="该部门下的部门人数关注企业微信（企业号）和新家校之和，任何一个手机关注即算关注"
                overlayClassName="address-book-dept-manage-tip"
              >
                {title}
                <Icon type="question-circle" theme="filled" />
              </Tooltip>
            );
          }
        });

        if (headers && headers.length && actionBtn) {
          headers.push(actionBtn);
        }

        yield put({
          type: 'save',
          payload: {
            data: rows.map((item, index) => ({
              ...item,
              dataIndex: index,
            })),
            pattern,
            tableDataCount: rows.length,
            columns: headers,
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 获取下级部门列表数据
    *fetchSearch({ searchParams, pattern }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { rows } = yield call(searchList, searchParams);

        yield put({
          type: 'save',
          payload: {
            data: rows,
            pattern,
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 单条删除
    *fetchDetele({ payload, calback }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '删除中...' });

        yield call(deleteData, payload);

        let newSelectedRowKeys = [];
        const { deptId } = payload;
        const { selectedRowKeys } = yield select(state => state.countySubDeptartmentForm);

        const index = selectedRowKeys.indexOf(deptId);
        if (index > -1) {
          selectedRowKeys.splice(index, 1);
          newSelectedRowKeys = selectedRowKeys;
        }

        message.success('删除部门成功');

        yield setSpinProps({
          put,
          selectedRowKeys: newSelectedRowKeys,
        });
        if (calback) {
          calback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量删除
    *fetchDelBatchs({ payload, calback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '删除中...' });

        yield call(delBatchs, payload);

        message.success('删除部门成功');
        yield setSpinProps({ put, selectedRowKeys: [], tableId: setNanoId({ str: 'tableKey' }) });
        if (calback) {
          calback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 编辑部门名称
    *fetchEditDeptName({ payload, calback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '编辑中...' });

        yield call(editDeptName, payload);
        message.success('编辑成功');

        if (calback) {
          calback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 添加单个子部门
    *fetchAdd({ payload, calback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '添加中...' });

        yield call(addDept, payload);
        message.success('添加成功');

        if (calback) {
          calback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    *fetchAddBatch({ payload, calback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '添加中...' });

        yield call(addBatchDept, payload);
        message.success('添加成功');

        if (calback) {
          calback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 获取部门类型列表
    *fetchDeptTypeList(_, { call, put }) {
      try {
        const { types } = yield call(getDeptTypeList);

        yield put({
          type: 'save',
          payload: {
            deptTypeList: types,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 获取部门类型和推荐名称列表
    *fetchDeptTypeAndRecommedList(_, { call, put }) {
      try {
        const { types } = yield call(getDeptTypeAndRecommmend);

        yield put({
          type: 'save',
          payload: {
            deptTypeList: types,
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 保存上传数据到deptUpload中
    *saveUploadData({ params, callback }, { put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '导入中...' });

        // 保存数据
        yield put({
          type: 'countyDeptUpload/save',
          payload: params,
        });

        yield setSpinProps({ put });
        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 排序
    *fetchSort({ params, data }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '保存中...' });

        yield call(sort, params);

        yield setSpinProps({ put, data });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量获取部门信息
    *fetchDeptInfos({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '获取数据中...' });

        const { infos = [] } = yield call(getDeptIds, params);

        let isHasSubDept = false;
        let isHasMementAndUserPost = false;
        (infos || []).forEach(({ subDeptCount = 0, memberCount = 0, userPostCount = 0 }) => {
          if (subDeptCount !== 0) {
            isHasSubDept = true;
          }
          if (memberCount !== 0 || userPostCount !== 0) {
            isHasMementAndUserPost = true;
          }
        });

        yield setSpinProps({ put });
        return Promise.resolve({ isHasSubDept, isHasMementAndUserPost });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
        return Promise.reject(error);
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
